import { ConvoTypes } from '@/store/enums';

export default [
    { id: ConvoTypes.Scripted, name: 'Scripted' },
    { id: ConvoTypes.TriviaQuiz, name: 'Trivia' },
    { id: ConvoTypes.PersonalityQuiz, name: 'Personality' },
];
